<template>
	<div
		id="config-management"
		:class="[!isWeb ? 'mobile-config-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="config-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<ConfigTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshUsers="refreshUsers"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_ADMINS } from '@/store/modules/configManagement/actions';
import TableFilter from '@/components/modules/Administrator/AdministratorManagement/TableFilter/TableFilter.vue';
import ConfigTable from '@/components/modules/Administrator/AdministratorManagement/Table/Table.vue';

export default {
	name: 'AdministratorManagement',
	components: { TableFilter, ConfigTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshUsers();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('configManagement', {
			getAdmins: GET_ALL_ADMINS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshUsers();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshUsers();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshUsers();
		},
		refreshUsers() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getAdmins({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'AdministratorManagement.scss';
</style>
